import React from 'react';
import { defaultNotifier } from 'functions/notificationHandler';
import { VuiButton } from '@topkamera/viso-ui';

const MICROSOFT_CLIENT_ID_KEY = process.env.MICROSOFT_CLIENT_ID_KEY || '';
const MICROSOFT_TENANT_ID_KEY = process.env.MICROSOFT_TENANT_ID_KEY || '';

const MicrosoftButton = () => {
  const clientId = MICROSOFT_CLIENT_ID_KEY;
  const tenantId = MICROSOFT_TENANT_ID_KEY;
  const redirectUri = `${window.location.origin}/viso-sso/microsoft`;

  const onMicrosoftLogin = async () => {
    if (!clientId) {
      return defaultNotifier('Microsoft client ID is not configured');
    }
    if (!tenantId) {
      return defaultNotifier('Microsoft tenant ID is not configured');
    }
    try {
      const genRandomString = (len = 32) => {
        const arr = new Uint8Array(len);
        window.crypto.getRandomValues(arr);
        return Array.from(arr, (b) => ('0' + (b & 0xff).toString(16)).slice(-2)).join('');
      };
      const base64url = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i += 1) {
          binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      };
      const generateCodeVerifier = () => {
        const random = new Uint8Array(32);
        window.crypto.getRandomValues(random);
        return base64url(random);
      };
      const computeCodeChallenge = async (verifier) => {
        const data = new TextEncoder().encode(verifier);
        const digest = await window.crypto.subtle.digest('SHA-256', data);
        return base64url(digest);
      };
      const state = genRandomString(16);
      const nonce = genRandomString(16);
      sessionStorage.setItem('ms_sso_state', state);
      sessionStorage.setItem('ms_sso_nonce', nonce);
      const codeVerifier = generateCodeVerifier();
      sessionStorage.setItem('ms_pkce_verifier', codeVerifier);
      const codeChallenge = await computeCodeChallenge(codeVerifier);
      const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize`;
      const params = new URLSearchParams({
        client_id: clientId,
        response_type: 'code',
        redirect_uri: redirectUri,
        scope: 'openid profile offline_access',
        response_mode: 'query',
        prompt: 'select_account',
        state,
        nonce,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
      });
      window.location.assign(`${authUrl}?${params.toString()}`);
    } catch (e) {
      defaultNotifier('Login with Microsoft failed');
    }
  };

  // if (!clientId) return null;

  return (
    <VuiButton
      onClick={onMicrosoftLogin}
      color='white'
      style='filled'
      radius='pill'
      label='Microsoft'
      iconLeft='microsoftLogo'
      isBlock
    />
  );
};

export default MicrosoftButton